import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ReactGA from 'react-ga4';
import * as Sentry from '@sentry/react';

if (import.meta.env.VITE_APP_ENV !== 'debug') {
  Sentry.init({
    dsn: 'https://604e9ce64917ee8539bcc2d2da158ee9@o4508968300445696.ingest.us.sentry.io/4508968305360896',
    environment: import.meta.env.VITE_APP_ENV,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

const MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;

// Initialize Google Analytics
ReactGA.initialize(MEASUREMENT_ID);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
